import {
  Box,
  Grid,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import React, { useEffect, useState } from "react";
import { setUpOrgVariable } from "../../Components/API/ZohoAPICalling";
import {
  EXTENSION_IDENTIFIER,
  Use_Login_User_Credential_API_NAME,
} from "../../config/serviceConstant";
import ZohoAuthenticationPage from "./ZohoAuthenticationPage";
import { setValue } from "../../Components/API/ApiCalling";

const ZOHO = window.ZOHO;
function Authentication(props) {
  const {
    children,
    tabIndex,
    index,
    orgId,
    apiKey,
    dataCenterUrl,
    dataCenter,
    zApiKey,
    zuid,
    setZuid,
    setAuth,
    connName,
    serviceApiKey,
    setServiceApiKey,
    users,
    currentUser,
    useLoginUserCredential,
    defaultAuthenticator,
    setUseLoginUserCredential,
    authenticatedUserMap,
    setAuthenticatedUserMap,
    setTabIndex,
    setSnack,
    ...other
  } = props;

  const [zohoAuth, setZohoAuth] = useState(false);
  const [flag, setFlag] = useState(false);

  const handleChangeTriggerApproval = async (event) => {
    // setTriggerApproval(event.target.checked);
    setUseLoginUserCredential((prev) => event.target.checked);
    if (event.target.checked) {
      await setUpOrgVariable(ZOHO, Use_Login_User_Credential_API_NAME, "ON");
    } else {
      await setUpOrgVariable(ZOHO, Use_Login_User_Credential_API_NAME, "OFF");
    }
    try {
      let uniqueKey = `${orgId}__${EXTENSION_IDENTIFIER}__orgvariables`;
      const setOrgvlaue = await setValue({ key: uniqueKey, value: "" });
    } catch (error) {}
  };

  useEffect(() => {
    if (flag) {
      if (orgId && apiKey && zApiKey && dataCenterUrl && dataCenter) {
        if (zohoAuth) {
          setAuth((prev) => true);
          setTabIndex((prev) => 1);
        } else {
          setAuth((prev) => false);
        }
      }
    }else{
      setFlag(prev=> true)
    }
  }, [zohoAuth]);

  return (
    <div
      role="tabpanel"
      hidden={tabIndex !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box sx={{ mx: "auto", py: 1, maxWidth: "1148px" }}>
        <FormControlLabel
          label="Use Log in User Credential"
          control={
            <Checkbox
              checked={useLoginUserCredential}
              disabled={
                defaultAuthenticator != currentUser?.email ||
                Object.keys(authenticatedUserMap)?.length >= 2 ||
                (Object.keys(authenticatedUserMap)?.length == 1 &&
                  Object.keys(authenticatedUserMap)?.[0] !=
                    defaultAuthenticator)
              }
              onChange={handleChangeTriggerApproval}
              inputProps={{ "aria-label": "controlled" }}
            />
          }
        />

        <Typography
          component="p"
          sx={{
            bgcolor: "#FEF7E0",
            mt: ".5rem",
            mb: "1.5rem",
            // height: "3rem",
            fontWeight: "regular",
            fontSize: "14px",
            lineHeight: "150%",
            letterSpacing: "0.15px",
            py: ".75rem",
            px: "1rem",
            color: "rgba(0,0,0,.87)",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <WarningAmberIcon
            sx={{ my: "auto", mr: ".7rem", color: "#A85D00" }}
          />
          <Box component="span" sx={{ mb: "-.35rem" }}>
            Actions will be performed using the current user's credentials. If
            unchecked, actions will be executed on behalf of the organization email({defaultAuthenticator}).
          </Box>
        </Typography>
        <ZohoAuthenticationPage
          zohoAuth={zohoAuth}
          setZohoAuth={setZohoAuth}
          orgId={orgId}
          apiKey={apiKey}
          dataCenterUrl={dataCenterUrl}
          connName={connName}
          dataCenter={dataCenter}
          zApiKey={zApiKey}
          zuid={zuid}
          setZuid={setZuid}
          users={users}
          currentUser={currentUser}
          useLoginUserCredential={useLoginUserCredential}
          defaultAuthenticator={defaultAuthenticator}
          authenticatedUserMap={authenticatedUserMap}
          setAuthenticatedUserMap={setAuthenticatedUserMap}
          setSnack={setSnack}
        />
      </Box>
    </div>
  );
}

export default Authentication;
